<template>
  <router-link :to="{ name: route }">
    <card :show-footer-line="true" class="card-button">
      <div class="row flex-nowrap">
        <div class="col">
          <slot>
            <h3 v-if="title" class="card-title text-uppercase text-muted mt-2 mb-0">{{ title }}</h3>
            <span v-if="subTitle" class="h5 font-weight-bold mb-0">{{ subTitle }}</span>
          </slot>
        </div>

        <div v-if="$slots.icon || icon" class="col-auto">
          <slot name="icon">
            <div :class="[`bg-${type}`, iconClasses]" class="icon icon-shape text-white rounded-circle shadow">
              <i :class="icon"></i>
            </div>
          </slot>
        </div>
      </div>

      <badge v-if="badge" class="mb-0 text-white position-absolute" :class="badgeColor">
        <span>{{ badge }}</span>
      </badge>
    </card>
  </router-link>
</template>

<script>
import Card from './Card.vue';

export default {
  name: 'ButtonCard',
  components: {
    Card,
  },

  props: {
    meta: {
      type: Object,
      default: () => {
        return {};
      },
    },

    route: {
      type: String,
      default: 'Dashboard',
    },

    type: {
      type: String,
      default: 'primary',
    },

    badge: {
      type: String,
      default: null,
    },

    badgeColor: {
      type: String,
      default: null,
    },

    icon: String,
    title: String,
    subTitle: String,
    iconClasses: [String, Array],
  },
};
</script>

<style scoped>
.badge {
  position: absolute;
  bottom: 0.5rem;
  font-size: 0.7rem;
  padding: 0.3rem;
  font-weight: bold;
  letter-spacing: 1px;
  text-align: center;
}
</style>
